import React, { Component } from 'react';
import update from 'immutability-helper';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import './Products.scss';
// import Select from 'react-select';
// import makeAnimated from 'react-select/lib/animated';
// import TableSales from '../../Components/Table-Sales/Table-Sales';
// import ModalAlteracoes from '../../Components/Modal-Alteracoes/Modal-Alteracoes';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import HeaderProduto from '../../Components/Header-Produto/Header-Produto';
import ModalPendencias from '../../Components/Modal-Pendencias/Modal-Pendencias';
import InputTag from '../../Components/Input-Tag/Input-Tag';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';



class ProductDetails extends Component {

    constructor(props) {
        super(props);

        this.onChangeInput = this.onChangeInput.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleCheckPeriodos = this.handleCheckPeriodos.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onDateChangeProm = this.onDateChangeProm.bind(this);
        this.getArrayPeriodos = this.getArrayPeriodos.bind(this);
        this.excluirProm = this.excluirProm.bind(this);
        this.adicionarProm = this.adicionarProm.bind(this);
        this.handleSelectPeriodChange = this.handleSelectPeriodChange.bind(this);
        this.scrollPromocao = this.scrollPromocao.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.setInitialState = this.setInitialState.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.toggleModalProm = this.toggleModalProm.bind(this);
        this.validaPeriodos = this.validaPeriodos.bind(this);
        this.mudaStatusProduto = this.mudaStatusProduto.bind(this);
        this.toggleSucessoAlteracao = this.toggleSucessoAlteracao.bind(this);
        this.toggleModalPendencia = this.toggleModalPendencia.bind(this);
        this.habilitaSalvar = this.habilitaSalvar.bind(this);
        this.atualizaTags = this.atualizaTags.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);




        this.Configurations = new Configurations();

        this.state = {
            tags: [],
            hasError: false,
            errorMessage: '',
        };

        this.periodOptions = [
            { label: "Mensal", value: 1, ativo: false, },
            { label: "Trimestral", value: 2, ativo: false, },
            { label: "Semestral", value: 3, ativo: false, },
            { label: "Anual", value: 4, ativo: false, },
            { label: "Unitário", value: 5, ativo: false, },
            // idPeriodo: , ativo:
        ];

        this.produtoMOCK = {
            nome: 'Meninos do Japão',
            sigla: 'MJ',
            descricao: 'Revista de orientações para o público infanto-juvenil',
            idTipoProduto: 2,
            foto: '',
            idOrigem: 2,
            idioma: 'Japonês',
            peso: '50',
            pesoEmbalagem: '70',
            autor: 'Daisaku Ikeda',
            cile: true,
            dtLancamento: "2019-10-29T15:00:00.000Z",
            isbn: null,
            ativo: true,
            periodos: [
                { idPeriodo: 1, ativo: true },
                { idPeriodo: 2, ativo: true },
                { idPeriodo: 3, ativo: false },
                { idPeriodo: 4, ativo: false },
                { idPeriodo: 5, ativo: true }
            ],
            valorUnitario: 12.40,
            fatorPeriodo: 2,
            // promocoes: [
            //     {
            //         nomePromocao: "sorteio instagram",
            //         nomePeriodoPromocao: "Mensal",
            //         idPeriodoPromocao: 1,
            //         vigenciaPromocao: {
            //             dtInicio: "2019-10-29T15:00:00.000Z",
            //             dtFim: "2019-10-29T15:00:00.000Z",
            //         },
            //         desconto: {
            //             percentual: true,
            //             valor: 10,
            //         }

            //     },
            //     {
            //         nomePromocao: "cupom HK",
            //         nomePeriodoPromocao: "Unitário",
            //         idPeriodoPromocao: 5,
            //         vigenciaPromocao: {
            //             dtInicio: "2019-10-29T15:00:00.000Z",
            //             dtFim: "2019-10-29T15:00:00.000Z",
            //         },
            //         desconto: {
            //             percentual: false,
            //             valor: 3.50,
            //         }
            //     }
            // ]
        }
    }

    componentWillMount() {
        this.setState({ isLoadingProduto: true })
        if (this.props.match.params.idProduto !== "novo-produto") {
            axios.get(this.Configurations.apiBasePath + `/produtos/${this.props.match.params.idProduto}`).then(response => {
                this.carregaInfosProduto(response.data.produto);
            }).catch(err => console.log(err)).finally(() => {
            });
        } else this.setInitialState();
    }

    setInitialState() {
        const _initialState = {
            produto: {
                nome: '',
                sigla: '',
                descricao: '',
                idTipoProduto: 1,
                foto: '',
                idOrigem: 1,
                idioma: '',
                peso: '',
                pesoEmbalagem: '',
                autor: '',
                cile: false,
                dtLancamento: null,
                isbn: null,
                ativo: false,
                periodos: [
                    { idPeriodo: 1, ativo: false },
                    { idPeriodo: 2, ativo: false },
                    { idPeriodo: 3, ativo: false },
                    { idPeriodo: 4, ativo: false },
                    { idPeriodo: 5, ativo: false },
                ],
                valorUnitario: '',
                fatorPeriodo: 2,
            },
            checkUnitario: false,
            checkMensal: false,
            checkTrimestral: false,
            checkSemestral: false,
            checkAnual: false,

            // vigenciaPromocao: {},

            // opcaoDesconto: "percentual",
            // valorDesconto: '',
            // nomePromocao: '',
            // promocoes: [],
            modalProm: false,

            novoProduto: this.props.match.params.idProduto === "novo-produto",
            periodOptions: this.periodOptions,
            isLoadingProduto: false,
            isLoadingStatus: false,
            isLoadingAlteracoes: false,
            modalAlteracoes: false,

            validPeriodicidade: true,
            validPeriodos: true,
            validUnitario: true,

            modalSucessoAlteracao: false,

            modalPendencia: false,
            pendencias: [],
        }
        this.setState(_initialState);
    }

    carregaInfosProduto(_infosProduto) {
        const _produto = _infosProduto;
        const _newState = {
            produto: _produto,
            // checkUnitario: _produto.periodos.indexOf(5) >= 0,
            // checkMensal: _produto.periodos.indexOf(1) >= 0,
            // checkTrimestral: _produto.periodos.indexOf(2) >= 0,
            // checkSemestral: _produto.periodos.indexOf(3) >= 0,
            // checkAnual: _produto.periodos.indexOf(4) >= 0,
            checkUnitario: _produto.periodos.filter(item => item.idPeriodo === 5)[0].ativo,
            checkMensal: _produto.periodos.filter(item => item.idPeriodo === 1)[0].ativo,
            checkTrimestral: _produto.periodos.filter(item => item.idPeriodo === 2)[0].ativo,
            checkSemestral: _produto.periodos.filter(item => item.idPeriodo === 3)[0].ativo,
            checkAnual: _produto.periodos.filter(item => item.idPeriodo === 4)[0].ativo,
            // promocoes: _produto.promocoes,
            nomeProduto: _produto.nome,
            // vigenciaPromocao: {
            //     dtInicioPromocao: null,
            //     dtFimPromocao: null,
            // },
            // opcaoDesconto: "percentual",
            // valorDesconto: '',
            novoProduto: false,
            periodOptions: this.periodOptions,
            modalAlteracoes: false,
            modalSucessoAlteracao: false,
            modalProm: false,
            modalPendencia: false,
            pendencias: [],
            tags: Array.isArray(_produto.tags) ? _produto.tags : [],
            imagemAlt: _produto.imagemAlt,
            metaTitle: _produto.metaTitle,
            metaDescription: _produto.metaDescription
        }
        this.setState(_newState, () => {
            this.validaPeriodos();
            this.setState({ versaoAtual: _produto, isLoadingProduto: false });
        })
    }

    onChangeInput(e, prod = null) {
        e.preventDefault();
        const _name = e.target.name;
        if (prod) this.setState({ produto: update(this.state.produto, { [_name]: { $set: e.target.value } }) });
        else this.setState({ [_name]: e.target.value })
    }

    handleRadio(e, desconto = null) {
        const _name = e.target.name;
        const _value = e.target.value;

        if (desconto) {
            this.setState({ [_name]: e.target.value })
        } else this.setState({ produto: update(this.state.produto, { [_name]: { $set: _value } }) }, () => {
            if (_name === "idTipoProduto") this.validaPeriodos();
        })
    }

    handleCheck(e) {
        this.setState({ produto: update(this.state.produto, { [e.target.name]: { $set: !this.state.produto[e.target.name] } }) })
    }

    handleCheckPeriodos(e) {
        this.setState({ [e.target.value]: !this.state[e.target.alue] }, () => this.getArrayPeriodos())
    }

    onDateChange(date) {
        this.setState({ produto: update(this.state.produto, { dtLancamento: { $set: date } }) });
    }

    onDateChangeProm(date) {
        const _vigencia = {
            dtInicioPromocao: date.startDate,
            dtFimPromocao: date.endDate
        }
        this.setState({ vigenciaPromocao: _vigencia })
    }

    _outsideRange(day) {
        // return day.format() < moment().format();
        return false
    }

    getArrayPeriodos() {

        let _periodos = [
            { idPeriodo: 1, ativo: this.state.checkMensal },
            { idPeriodo: 2, ativo: this.state.checkTrimestral },
            { idPeriodo: 3, ativo: this.state.checkSemestral },
            { idPeriodo: 4, ativo: this.state.checkAnual },
            { idPeriodo: 5, ativo: this.state.checkUnitario },
        ];

        // _periodos = _periodos.filter(item => item.ativo).map(item => item.idPeriodo);
        this.setState({ produto: update(this.state.produto, { periodos: { $set: _periodos } }) });


        // RESTRIÇÃO para períodos disponíveis
        // let _opcoesPeriodos = this.periodOptions.filter(
        //     item => {
        //         return _periodos.indexOf(item.value) >= 0;
        //     });
        // this.setState({ periodOptions: _opcoesPeriodos })
    }

    excluirProm(_index) {
        const _promocoes = update(this.state.promocoes, { $splice: [[_index, 1]] });
        this.setState({
            promocoes: _promocoes,
            // exibePedido: true,
            isLoadingPromocao: false,
        })
    }

    adicionarProm() {
        const _dtInicio = this.state.vigenciaPromocao.dtInicioPromocao !== null,
            _dtFim = this.state.vigenciaPromocao.dtFimPromocao !== null,
            _desconto = this.state.valorDesconto !== '',
            _nome = this.state.nomePromocao !== '',
            _periodo = this.state.idPeriodoPromocao !== undefined,
            _promoValida = _dtInicio * _dtFim * _desconto * _nome * _periodo;

        if (_promoValida) {
            this.setState({ isLoadingPromocao: true })
            let _promocoes = this.state.promocoes;

            const _desc = this.state.valorDesconto,
                _percent = this.state.opcaoDesconto === "percentual";

            _promocoes.push({
                "nomePromocao": this.state.nomePromocao,
                "idPeriodoPromocao": this.state.idPeriodoPromocao.value,
                "nomePeriodoPromocao": this.state.idPeriodoPromocao.label,
                "desconto": { valor: _desc, percentual: _percent },
                "dtInicio": this.state.vigenciaPromocao.dtInicioPromocao.toISOString(),
                "dtFim": this.state.vigenciaPromocao.dtFimPromocao.toISOString(),
            })
            this.setState({ promocoes: [] }, () => {
                this.setState({
                    promocoes: _promocoes,
                    isLoadingPromocao: false,
                }, () => {
                    this.setState({
                        nomePromocao: '',
                        idPeriodoPromocao: null,
                        valorDesconto: '',
                        vigenciaPromocao: {}
                    })
                    this.scrollPromocao();
                })
            })
        } else this.toggleModalProm();
    }

    handleSelectPeriodChange(o, e,) {
        if (e.action === "clear") this.setState({ [e.name]: null })
        else this.setState({
            [e.name]: { value: o.value, label: o.label },
        })
    }

    scrollPromocao() {
        var element = document.getElementById("tabela-promocoes");
        element.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    habilitaSalvar() {
        const _nomeValido = this.state.produto.nome.trim() !== '',
            _siglaValida = this.state.produto.sigla.trim() !== '',
            _idiomaValido = this.state.produto.idioma.trim() !== '',
            _autorValido = this.state.produto.autor.trim() !== '',
            _descricaoValida = this.state.produto.descricao.trim() !== '',
            _dtLancamentoValida = this.state.produto.dtLancamento !== null,
            _valorValido = this.state.produto.valorUnitario !== '' && this.state.produto.valorUnitario > 0,
            _periodosValidos = this.state.produto.periodos.filter(item => item.ativo).length > 0 || parseInt(this.state.produto.idTipoProduto, 10) === 4;


        const _infosObrigatorias = [
            { campo: "Nome do Produto", valido: _nomeValido },
            { campo: "Sigla", valido: _siglaValida },
            { campo: "Idioma", valido: _idiomaValido },
            { campo: "Autor", valido: _autorValido },
            { campo: "Descrição", valido: _descricaoValida },
            { campo: "Data de Lançamento", valido: _dtLancamentoValida },
            { campo: "Valor Unitário", valido: _valorValido },
            { campo: "Períodos disponíveis", valido: _periodosValidos },
        ]

        const _pendencias = _infosObrigatorias.filter(item => !item.valido);

        this.setState({ habilitaSalvar: _pendencias.length <= 0 }, () => this.salvarAlteracoes(_pendencias))
    }

    salvarAlteracoes(_pend) {
        if (this.state.habilitaSalvar) {
            this.setState({ isLoadingAlteracoes: true })
            const _infosProduto = {
                ...this.state.produto,
                dtLancamento: this.state.produto.dtLancamento,
                // promocoes: this.state.promocoes,
                tags: this.state.tags,
                imagemAlt: this.state.imagemAlt,
                metaTitle: this.state.metaTitle,
                metaDescription: this.state.metaDescription
            };
            this.setState({ produto: _infosProduto }, () => {
                if (this.state.novoProduto) {
                    axios.post(this.Configurations.apiBasePath + `/produtos`, this.state.produto).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => {
                        this.setState({ isLoadingAlteracoes: false })
                    });
                } else {
                    axios.put(this.Configurations.apiBasePath + `/produtos/${this.props.match.params.idProduto}`, this.state.produto).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => {
                        this.setState({ isLoadingAlteracoes: false })
                    });
                }
            })
        } else {
            this.setState({ pendencias: _pend }, () => this.toggleModalPendencia());
        }

    }

    toggleModalPendencia() {
        this.setState({ modalPendencia: !this.state.modalPendencia })
    }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }

    toggleModalProm() {
        this.setState({ modalProm: !this.state.modalProm })
    }

    validaPeriodos() {
        if (parseInt(this.state.produto.idTipoProduto, 10) === 4) { // livros
            this.setState({
                checkUnitario: false,
                checkMensal: false,
                checkTrimestral: false,
                checkSemestral: false,
                checkAnual: false,
                validPeriodicidade: false,
                validPeriodos: false,
                validUnitario: false,
                produto: update(this.state.produto, { fatorPeriodo: { $set: 1 }, idPeriodicidade: { $set: 3 } })
            });

        } else if (parseInt(this.state.produto.idTipoProduto, 10) === 3) { // digital
            this.setState({
                checkUnitario: false,
                validPeriodicidade: true,
                validPeriodos: true,
                validUnitario: false,
            }, () => { if (this.state.novoProduto) this.setState({ produto: update(this.state.produto, { fatorPeriodo: { $set: 2 } }) }) });

        } else this.setState({
            validPeriodicidade: true,
            validPeriodos: true,
            validUnitario: true,
        }, () => { if (this.state.novoProduto) this.setState({ produto: update(this.state.produto, { fatorPeriodo: { $set: 2 } }) }) });
    }

    mudaStatusProduto(_metodo) {
        this.setState({ isLoadingStatus: true });
        axios.put(this.Configurations.apiBasePath + `/produtos/${this.props.match.params.idProduto}/${_metodo}`).then(response => { this.toggleSucessoAlteracao(); }).catch(err => {
            console.log(err);
        }).finally(() => {
            this.setState({ isLoadingStatus: false })
        })
    }

    toggleSucessoAlteracao() {
        if (this.state.modalSucessoAlteracao) {
            this.setState({ modalSucessoAlteracao: false }, () =>
                window.history.go(-1)
            );
        } else this.setState({ modalSucessoAlteracao: true })
    }

    atualizaTags(_tags) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ tags: _tags })
    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.error.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    render() {
        return (
            <div className="row product-details mb-3">
                {!this.state.isLoadingProduto && (
                    <HeaderProduto
                        salvarAlteracoes={this.habilitaSalvar}
                        toggleModalAlteracoes={this.toggleModalAlteracoes}
                        produto={this.state.produto}
                        mudaStatusProduto={this.mudaStatusProduto}
                        novoProduto={this.state.novoProduto}
                        versaoAtual={this.state.versaoAtual}
                        isLoadingAlteracoes={this.state.isLoadingAlteracoes}
                        isLoadingStatus={this.state.isLoadingStatus}
                    />
                )}
                <div className="div-produto mb-3">
                    <div className="col-12">
                        {this.state.isLoadingProduto ? (
                            <div className="row">
                                <div className="col-12 py-3 text-center">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-12">
                                    <div className="row no-gutters align-items-center">
                                        <div className="col-12">
                                            {this.state.novoProduto ? (
                                                <h2 className="title-1">Cadastro de Novo Produto</h2>
                                            ) : (
                                                <h2 className="title-1">Detalhes do Produto - {this.state.nomeProduto}</h2>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-3 py-3">
                                    <label>Nome do Produto<sup><small>(*)</small></sup></label>
                                    <input name="nome" type="text" className="form-control" onChange={(e) => this.onChangeInput(e, true)} value={this.state.produto.nome} autoComplete="off" />
                                </div>
                                <div className="col-12 col-lg-1 py-3">
                                    <label>Sigla</label>
                                    <input name="sigla" type="text" className="form-control" onChange={(e) => this.onChangeInput(e, true)} value={this.state.produto.sigla} autoComplete="off" />
                                </div>
                                <div className="col-12 col-lg-2 py-3">
                                    <label>Idioma</label>
                                    <input name="idioma" type="text" className="form-control" onChange={(e) => this.onChangeInput(e, true)} value={this.state.produto.idioma} autoComplete="off" />
                                </div>
                                <div className="col-12 col-lg-3 py-3">
                                    <label>Autor</label>
                                    <input name="autor" type="text" className="form-control" onChange={(e) => this.onChangeInput(e, true)} value={this.state.produto.autor} autoComplete="off" />
                                </div>
                                <div className="col-12 col-lg-3 py-3 mt-lg-4 mt-0 d-flex align-items-center">
                                    <div className="form-check">
                                        <input type="checkbox" className="form-check-input" name="cile" onChange={this.handleCheck} checked={this.state.produto.cile} />
                                        <label className="form-check-label">É produto do CILE</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label>Descrição</label>
                                    <textarea id="descr" type="text" className="form-control" name="descricao" value={this.state.produto.descricao} onChange={(e) => this.onChangeInput(e, true)} />
                                </div>
                                <div className="col-12 col-lg-2 py-3">
                                    <label className="d-block">Dt. Lançamento</label>
                                    <SingleDatePicker
                                        date={this.state.produto.dtLancamento !== null ? moment(this.state.produto.dtLancamento) : null} // momentPropTypes.momentObj or null
                                        onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                        focused={this.state.focused} // PropTypes.bool
                                        onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                        id="dtLancamento" // PropTypes.string.isRequired,
                                        verticalHeight={450}
                                        numberOfMonths={1}
                                        small={true}
                                        phrases={this._phrases}
                                        isOutsideRange={this._outsideRange}
                                        placeholder=""
                                        block={true}
                                    />
                                </div>
                                <div className="col-12 col-lg-2 py-3">
                                    <label>Valor unitário <small>(R$)</small></label>
                                    <input name="valorUnitario" type="number" className="form-control" onChange={(e) => this.onChangeInput(e, true)} value={this.state.produto.valorUnitario} autoComplete="off" />
                                </div>
                                <div className="col-12 col-lg-2 py-3">
                                    <label>Peso <small>(g)</small></label>
                                    <input name="peso" type="number" className="form-control" onChange={(e) => this.onChangeInput(e, true)} value={this.state.produto.peso} autoComplete="off" />
                                </div>
                                <div className="col-12 col-lg-3 py-3">
                                    <label>Peso com embalagem <small>(g)</small></label>
                                    <input name="pesoEmbalagem" type="number" className="form-control" onChange={(e) => this.onChangeInput(e, true)} value={this.state.produto.pesoEmbalagem} autoComplete="off" />
                                </div>
                                <div className={`col-12 col-lg-2 py-3`}>
                                    {/* espaço em branco (antigo "estoque") */}
                                </div>
                                <div className="col-12 col-lg-12 py-3 text-left tags-products">
                                    <label>Tags</label>
                                    <InputTag atualizaTags={this.atualizaTags} tags={this.state.tags} textInput={true} />
                                </div>
                                <div className="col-12">
                                    <label>Imagem alt</label>
                                    <input name="imagemAlt" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.imagemAlt} autoComplete="off" />
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Meta title</label>
                                    <input name="metaTitle" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.metaTitle} autoComplete="off" />
                                </div>
                                <div className="col-12 mt-3">
                                    <label>Meta description</label>
                                    <input name="metaDescription" type="text" className="form-control" onChange={this.handleOnChange} value={this.state.metaDescription} autoComplete="off" />
                                </div>
                                <div className="col-12 col-lg-2 py-3">
                                    <label>Tipo do Produto</label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="idTipoProduto" id="jornal" checked={parseInt(this.state.produto.idTipoProduto, 10) === 1} value={1} onChange={this.handleRadio} />
                                        <label className="form-check-label" htmlFor="jornal">Jornal</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="idTipoProduto" id="revista" checked={parseInt(this.state.produto.idTipoProduto, 10) === 2} value={2} onChange={this.handleRadio} />
                                        <label className="form-check-label" htmlFor="revista">Revista</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="idTipoProduto" id="digital" checked={parseInt(this.state.produto.idTipoProduto, 10) === 3} value={3} onChange={this.handleRadio} />
                                        <label className="form-check-label" htmlFor="digital">Digital</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="idTipoProduto" id="livro" checked={parseInt(this.state.produto.idTipoProduto, 10) === 4} value={4} onChange={this.handleRadio} />
                                        <label className="form-check-label" htmlFor="livro">Livro</label>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-2 py-3">
                                    <label>Origem</label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="idOrigem" id="nac" checked={parseInt(this.state.produto.idOrigem, 10) === 1} value={1} onChange={this.handleRadio} />
                                        <label className="form-check-label" htmlFor="nac">Nacional</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="idOrigem" id="inter" checked={parseInt(this.state.produto.idOrigem, 10) === 2} value={2} onChange={this.handleRadio} />
                                        <label className="form-check-label" htmlFor="inter">Internacional</label>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-2 py-3">
                                    <label>Periodicidade</label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="fatorPeriodo" id="mensal" checked={parseInt(this.state.produto.fatorPeriodo, 10) === 2} value={2} onChange={this.handleRadio} disabled={!this.state.validPeriodicidade} />
                                        <label className="form-check-label" htmlFor="mensal">Mensal</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="fatorPeriodo" id="semanal" checked={parseInt(this.state.produto.fatorPeriodo, 10) === 1} value={1} onChange={this.handleRadio} disabled={!this.state.validPeriodicidade} />
                                        <label className="form-check-label" htmlFor="semanal">Semanal</label>
                                    </div>
                                    {parseInt(this.state.produto.idTipoProduto, 10) === 4 && (
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="fatorPeriodo" id="avulso" checked={parseInt(this.state.produto.fatorPeriodo, 10) === 1} value={3} onChange={this.handleRadio} />
                                            <label className="form-check-label" htmlFor="semanal">Avulso</label>
                                        </div>
                                    )}
                                </div>
                                <div className="col-12 col-lg-3 py-3">
                                    <label>Períodos disponíveis</label>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="periodos" id="unitario" checked={this.state.checkUnitario} value={"checkUnitario"} onChange={this.handleCheckPeriodos} disabled={!this.state.validUnitario} />
                                        <label className="form-check-label" htmlFor="unitario">Unitário</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="periodos" id="mensal" checked={this.state.checkMensal} value={"checkMensal"} onChange={this.handleCheckPeriodos} disabled={!this.state.validPeriodos} />
                                        <label className="form-check-label" htmlFor="mensal">Mensal</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="periodos" id="trimestral" checked={this.state.checkTrimestral} value={"checkTrimestral"} onChange={this.handleCheckPeriodos} disabled={!this.state.validPeriodos} />
                                        <label className="form-check-label" htmlFor="trimestral">Trimestral</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="periodos" id="semestral" checked={this.state.checkSemestral} value={"checkSemestral"} onChange={this.handleCheckPeriodos} disabled={!this.state.validPeriodos} />
                                        <label className="form-check-label" htmlFor="semestral">Semestral</label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" name="periodos" id="anual" checked={this.state.checkAnual} value={"checkAnual"} onChange={this.handleCheckPeriodos} disabled={!this.state.validPeriodos} />
                                        <label className="form-check-label" htmlFor="anuak">Anual</label>
                                    </div>
                                </div>

                                {/* <div className="col-12">
                                        <div className="row no-gutters">
                                            <div className="col-12 py-2">
                                                <h6>Cadastro de promoção</h6>
                                            </div>
                                            <div className={`col-12 col-lg-4 px-3 py-2`}>
                                                <div className="form-group m-0">
                                                    <label htmlFor="ddlPeriods">Período</label>
                                                    <Select
                                                        id="ddlPeriods"
                                                        placeholder="Selecione um período"
                                                        closeMenuOnSelect={true}
                                                        components={makeAnimated()}
                                                        options={this.state.periodOptions}
                                                        onChange={(o, e) => this.handleSelectPeriodChange(o, e)}
                                                        name="idPeriodoPromocao"
                                                        isClearable
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-3 py-2">
                                                <label>Nome da Promoção</label>
                                                <input name="nomePromocao" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.nomePromocao} autoComplete="off" />
                                            </div>
                                            <div className="col-12 col-lg-3 py-2">
                                                <label htmlFor="desconto">
                                                    Desconto
                                                    <div className="custom-control custom-radio custom-control-inline ml-3">
                                                        <input type="radio" id="percent" name="opcaoDesconto" className="custom-control-input" checked={this.state.opcaoDesconto === "percentual"} value="percentual" onChange={(e) => this.handleRadio(e, true)} />
                                                        <label className="custom-control-label" htmlFor="percent">%</label>
                                                    </div>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input type="radio" id="abs" name="opcaoDesconto" className="custom-control-input" checked={this.state.opcaoDesconto === "absoluto"} value="absoluto" onChange={(e) => this.handleRadio(e, true)} />
                                                        <label className="custom-control-label" htmlFor="abs">R$</label>
                                                    </div>
                                                </label>
                                                <input id="desconto" name="valorDesconto" className="form-control text-center" type="number" value={this.state.valorDesconto} onChange={this.onChangeInput} />
                                            </div>
                                            <div className="col-12 col-lg-5 py-2">
                                                <div className="form-group">
                                                    <label htmlFor="dpStartDate">Vigência da promoção</label><br />
                                                    <DateRangePicker
                                                        showClearDates
                                                        enableOutsideDays
                                                        isOutsideRange={this._outsideRange}
                                                        startDate={this.state.vigenciaPromocao.dtInicioPromocao} // momentPropTypes.momentObj or null,
                                                        startDateId="dtInicioPromocao" // PropTypes.string.isRequired,
                                                        endDate={this.state.vigenciaPromocao.dtFimPromocao} // momentPropTypes.momentObj or null,
                                                        endDateId="dtFimPromocao" // PropTypes.string.isRequired,
                                                        onDatesChange={this.onDateChangeProm} // PropTypes.func.isRequired,
                                                        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                        onFocusChange={focusedInput => this.setState({ focusedInput })}
                                                        displayFormat="DD/MM/YYYY"
                                                        startDatePlaceholderText="Data inicial"
                                                        endDatePlaceholderText="Data final"
                                                        phrases={this._phrases}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-3 d-flex align-items-end pb-4 mb-1 justify-content-center justify-content-lg-start">
                                                <button onClick={this.adicionarProm} className="btn btn-outline-info">adicionar promoção</button>
                                            </div>
                                            <div id="tabela-promocoes" className="col-12">
                                                <div className="row no-gutters">
                                                    <div key="itens" className="col-12 py-4">
                                                        <h6 className="text-center">Lista de Promoções</h6>
                                                        <div className="card">
                                                            <div className="card-body px-1">
                                                                <div className="row no-gutters px-3">
                                                                    <div className="col-12">
                                                                        <TableSales
                                                                            loading={this.state.isLoadingPromocao}
                                                                            promocoes={this.state.promocoes}
                                                                            excluirProm={this.excluirProm}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div> */}

                            </div>
                        )}
                    </div>
                </div>
                <Modal isOpen={this.state.modalSucessoAlteracao} toggle={this.toggleSucessoAlteracao}>
                    <ModalHeader toggle={this.toggleSucessoAlteracao}>
                        {this.state.novoProduto ? 'Novo Produto' : 'Edição de Produto'}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.novoProduto ? 'Novo produto criado com sucesso! :)' : 'Alterações realizadas com sucesso! :)'}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleSucessoAlteracao}>ok</Button>
                    </ModalFooter>
                </Modal>

                {/* <Modal isOpen={this.state.modalProm} toggle={this.toggleModalProm}>
                    <ModalHeader toggle={this.toggleModalProm}>Cadastro de Promoção</ModalHeader>
                    <ModalBody>
                        <p>Por favor, preencha todas as informações para cadastar uma promoção.</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleModalProm}>ok</Button>
                    </ModalFooter>
                </Modal> */}

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />

                <ModalPendencias
                    isOpen={this.state.modalPendencia}
                    toggle={this.toggleModalPendencia}
                    pendencias={this.state.pendencias}
                />
            </div>
        )
    }
}

export default ProductDetails;